import { render, staticRenderFns } from "./RegionsList.vue?vue&type=template&id=09a1a110"
import script from "./RegionsList.vue?vue&type=script&lang=ts"
export * from "./RegionsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports